<template>
  <div>
    <v-toolbar class="my-md-auto" elevation="0"  >
      <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
        <h1><v-icon large>mdi-qrcode</v-icon>{{$t('profile.material.productversions')}}</h1>
      </v-toolbar-title>
      <v-spacer />
      <div>
        <v-btn
          color=""
          class="ml-sm-2"
          @click="resetForm"
        >
          {{ $t('global.reset')}}
        </v-btn>
        <v-btn
          :loading="isLoading"
          class="ml-sm-2"
          color="primary"
          @click="onSendProdFileForm"
        >
          {{ $t('global.submit')}}
        </v-btn>
      </div>
    </v-toolbar>
    <MaterialProductVersionForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import MaterialProductVersionForm from '../../components/materialproductversion/Form';
import Loading from '../../components/Loading';
import CreateMixin from '../../mixins/CreateMixin';


const servicePrefix = 'MaterialProductVersion';

const { mapFields } = createHelpers({
  getterType: 'materialproductversion/getField',
  mutationType: 'materialproductversion/updateField'
});

export default {
  name: 'MaterialProductVersionCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    MaterialProductVersionForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('materialproductversion', ['create', 'reset']),
    onSendProdFileForm() {
      this.onSendForm();
    }
  }
};
</script>
